import React, { useEffect, useState } from "react";
import { Grid, TextField, Button, MenuItem } from "@mui/material";
import axios from "axios";
import baseUrl from "../../../config/baseUrl";

function SettlementInfo() {
  const auth = sessionStorage.getItem("user");
  const [countryName, setCountryName] = useState([]);

  const merchantData = async () => {
    try {
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };

      let result = await axios.post(`${baseUrl}/currencySelect`, {}, config);
      setCountryName(result.data.result);
    } catch (error) {
      console.log(error);
    }
  };

  const [formState, setFormState] = useState({
    settle_currency: "",
    wallet_url: ""
  });

  const ReadData = async () => {
    try {
      let values = {
        tab: 7,
      };
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };
      let result = await axios.post(
        `${baseUrl}/defaultBusinesSettingData`,
        values,
        config
      );
      setFormState(result.data.result);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      let values = {
        settle_currency: formState.settle_currency,
        usdt_wallet_address: formState.wallet_url
      };

      const config = {
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${auth}`,
        },
      };

      let result = await axios.post(
        `${baseUrl}/save_settelment_info`,
        values,
        config
      );
      if (result.status === 200) {
        alert(result.data.message);
      } else {
        alert(result.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    ReadData();
    merchantData();
  }, []);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <TextField
            select
            fullWidth
            label="Settlement Currency"
            name="settle_currency"
            value={formState.settle_currency}
            variant="outlined"
            onChange={handleChange}
        >
            {countryName.map((country) => (
            <MenuItem key={country.value} value={country.label}>
                {country.label}
            </MenuItem>
            ))}
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Crypto Wallet Address"
          name="wallet_url"
          value={formState.wallet_url}
          variant="outlined"
          onChange={handleChange}
          helperText="Optional"
            InputLabelProps={{
                shrink: true
            }}
            FormHelperTextProps={{ sx: { color: 'orange' } }}
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <Button
          onClick={handleSave}
          variant="contained"
          color="success"
          size="medium"
          sx={{
            float: "inline-end",
          }}
        >
          Save
        </Button>
      </Grid>
    </Grid>
  );
}

export default SettlementInfo;
